import { PromoterStockDetails } from './PromoterStockDetails';

export const PromoterStock = () => <PromoterStockDetails />;
